module.exports = __webpack_public_path__ + "static/media/folder-archive-storage-svgrepo-com.b1b63cb9.svg";